import React from "react";
import "./lifeDeclaration.scss";
import Button from "../Button";
import { useHistory } from "react-router-dom";

export default function LifeDeclaration(props) {
  const history = useHistory();

  function handleClick() {
    history.push("/beneficiarios");
  }
  return (
    <div className="declaration-container">
      <h3>Por el presente cuestionario DECLARO:</h3>
      <ul>
        <li>
          <img src={require("./../../img/greencheck.png")} alt="" />
          <b>NO SUFRIR O HABER SUFRIDO ENFERMEDADES CARDIOVASCULARES</b>
          <br /> (hipertensión arterial, infartos, anginas de pecho, arritmias,
          etc), PULMONARES, GASTROINTESTINALES, GENITOURINARIAS, NEUROLÓGICAS O
          PSIQUIATRICAS
        </li>

        <li>
          {" "}
          <img src={require("./../../img/greencheck.png")} alt="" />
          <b>NO PADECER O HABER PADECIDO DIABETES, GOTA, TUMORES O CANCER</b>
        </li>

        <li>
          {" "}
          <img src={require("./../../img/greencheck.png")} alt="" />
          <b>
            NO PADECER O HABER PADECIDO OTRAS ENFERMEDADES NO INDICADAS EN LAS
            PREGUNTAS ANTERIORES
          </b>
        </li>
      </ul>
      <div className="button-container">
        <Button color="primary" onClick={() => props.closeModal(false)}>
          Volver
        </Button>
        <Button color="secondary" onClick={() => handleClick()}>
          Continuar
        </Button>
      </div>
    </div>
  );
}
